import { useNavigate } from 'react-router';
import { Segmented } from '../../../ds/components';
import styles from './ListSwitch.module.css';

type ListView = 'properties' | 'units';

/** The switch in the head of „Objekte" and „Alle Einheiten" (owner decision 19.10.2026, D-270). */
export function ListSwitch({ value }: { value: ListView }) {
  const navigate = useNavigate();
  return (
    <Segmented<ListView>
      label="Liste"
      className={styles.switch}
      value={value}
      items={[
        { value: 'properties', label: 'Objekte' },
        { value: 'units', label: 'Alle Einheiten' },
      ]}
      onChange={(next) => void navigate(next === 'units' ? '/properties/units' : '/properties')}
    />
  );
}
